export default "__VITE_PUBLIC_ASSET__8505e35d__"